module.exports = __webpack_public_path__ + "img/home-icon-ext-green.3e6e86ff.svg";